module.exports = __webpack_public_path__ + "static/beyond-entrepreneurship-c2b7fb3ac098082c6b84b0792dffe834.jpg";